import useAuthUser from './useAuthUser';
import { canOnInstance } from '../utils/access';
import { hasRole } from '../utils/roles';

/**
 * Does the signed-in person hold `action` on this Kuutio — the client's side
 * of the backend's requireGrant('instance', action) (specs/access-model.md).
 * Facilitator-only controls on a participant screen hang off this, never off
 * "is anyone signed in" (#1227): a participant who signed in on /me holds
 * participate, not facilitate, and the server refuses what the screen would
 * otherwise offer. Admins and owners hold everything, as on the server.
 * False until /auth/me has answered, so a control appears rather than vanishes.
 */
export default function useInstanceGrant(instanceId, action = 'facilitate') {
  const { user } = useAuthUser();
  return Boolean(user) && (hasRole(user, 'admin') || canOnInstance(user, instanceId, action));
}
